import type { QueryClient } from '@tanstack/react-query';

let refreshNonce = '';

/** Read at fetch time so refetches triggered by invalidation bust the CDN edge cache. */
export const getPortfolioRefreshNonce = () => refreshNonce;

export function invalidatePortfolioData(queryClient: QueryClient) {
  refreshNonce = String(Date.now());
  queryClient.invalidateQueries({ queryKey: ['wallet-portfolio'] });
  queryClient.invalidateQueries({ queryKey: ['wallet-positions'] });
  queryClient.invalidateQueries({ queryKey: ['wallet-pnl'] });
  queryClient.invalidateQueries({ queryKey: ['tokens-pnl'] });
}
